module.exports = __webpack_public_path__ + "img/datingpartners.7c4397c.png";